import React from 'react';

const BackIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path d="M15 18l-6-6 6-6" stroke="#2C2C2A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StepShell = ({ step, totalSteps = 6, title, subtitle, onBack, children }) => {
  return (
    <div className="ob-page">
      <div className="ob-card">
        <div className="ob-topbar">
          <button type="button" className="ob-back-btn" onClick={onBack} aria-label="Go back">
            <BackIcon />
          </button>
        </div>
        <div className="ob-step-label">Step {step} of {totalSteps}</div>
        <div className="ob-progress-track">
          <div className="ob-progress-fill" style={{ width: `${(step / totalSteps) * 100}%` }} />
        </div>
        <h1 className="ob-title">{title}</h1>
        {subtitle && <p className="ob-subtitle">{subtitle}</p>}
        <div className="ob-body">{children}</div>
      </div>
    </div>
  );
};

export default StepShell;
